export default function thousandsFormat(value?: number | string) {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  return value;
}
